<template>
  <component :is="$route.name" :readWrite="readWrite"></component>
</template>

<script>
import EventBus from '@/eventbus.js'

export default {
  name: 'groupbase',
  data () {
    return {
    }
  },
  props: ['readWrite'],
  watch: {
    '$route' (to, from) {
      EventBus.$emit('loading', true)
    }
  },
  components: {
    'groups': () => import('@/components/groups/groupList'),
    'groupEdit': () => import('@/components/groups/groupEdit'),
    'groupNew': () => import('@/components/groups/groupEdit')
  },
  created () {
    EventBus.$emit('loading', true)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/groupBase.vue